import _, { isArray, isPlainObject, clone, isObject, concat, times } from "lodash-es";
import {TSize} from "@/pages/datalab/components/GridBox/types";

export const getPositionCss = ({start, end, span}): string => {
  let css = '';
  if (start && end) {
    css = `${start} / ${end}`;
  } else if (start && span) {
    css = `${start} / span ${span}`;
  } else if (start) {
    // 只填写了 start
    css = `${start}`; // 指定起始位置，而跨度默认为1
  } else if (end && span) {
    // 这样填写 提示warning
    console.warn('请同时设置start和end!');
    css = `1 / ${end}`;
  } else if (end) {
    console.warn('请同时设置start和end!');
    css = `1 / ${end}`;
  } else {
    // 只设置了span, 跨几列;
    css = `span ${span}`;
  }
  return css;
};

/**
 * 使用Lodash将变量转换为数组并用'1fr'补充到指定长度
 * @param {Array|Object} input - 输入（数组或数字key的对象）
 * @param {number} targetLength - 目标数组长度
 * @returns {Array} 处理后的数组
 */
export const normalizeAndPad = (input, targetLength, padstr) => {
  // 1. 转换为数组
  let array = [];
  
  if (isArray(input)) {
    array = clone(input); // 使用_.clone复制数组
  }
  else if (isPlainObject(input)) {
    // 处理数字key的对象：提取数字key的值并按key排序
    array = _(input)
      .toPairs()
      .filter(([key]) => /^\d+$/.test(key)) // 只匹配数字key
      .sortBy(([key]) => _.parseInt(key))   // 按数字key排序
      .map(1)                               // 提取值
      .value();
  }
  
  // 2. 补充'1fr'到目标长度
  if (array.length < targetLength) {
    const needed = targetLength - array.length;
    array = concat(array, times(needed, _.constant(padstr)));
  }
  // 可选：截断超长部分
  // array = _.take(array, targetLength);
  
  return array;
};



export const getItemSize = (configs: (TSize|'auto')[]) => configs.map((item) => {
  
  if (item === 'auto') {
    return 'minmax(min-content, max-content)'; // 自适应
  }
  
  if (isObject(item)) {
    const {min, max, value} = item;
    
    // min 和 max 优先级大于 value
    if (min && max) { // 同时设置了min和max
      // 如果是单纯的数字, 则补充fr后缀
      // 如果是数字+px, 类似 100px, 则直接返回
      // 如果是 content, 则返回 前缀-content
      
      return `minmax(${min}, ${max})`;
    }
    if (min) { // 只设置了min, 保证最小可读宽度
      // 当 min > 1fr时 网格容器会出现水平滚动条（内容溢出）
      return `minmax(${min}, 1fr)`; // 最大可扩展到 1fr 分配的空间, 参与剩余空间分配
      
      // minmax(500px, auto)
      // return `minmax(${min}, auto)`; 最大由内容决定 (auto), 不参与剩余空间分配
    }
    
    if (max) { // 只设置了max, 限制最大宽度但允许缩小
      
      return `minmax(auto, ${max})`; // 第一个位置 1fr相当于auto
    }
    
    
    
    if (value === 'auto') {
      return 'minmax(min-content, max-content)'; // 自适应
    }
    
    return value;
  }
  
  // 没有设置的 默认 1fr
  return item || 'minmax(0, 1fr)';
}).join(' ');

